import "./heldsale.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import moment from "moment";
import { type ThunkDispatch } from "redux-thunk";
import { reloadInvoice } from "../../../Actions/SellScreen/SellScreenActions";
import NoTranslate from "../../../Common/NoTranslate";
import { type LocalDatabaseSale } from "../../../Data/_Bases/BaseSalesRepository";
import { type InjectedDataSourceProps, withDataSource } from "../../../Data/DataStores/WithDataSource";
import { currency } from "../../../Utilities/Generic/Numbers";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";

const connector = connect();

interface Props extends ConnectedProps<typeof connector>, InjectedDataSourceProps {
    dispatch: ThunkDispatch<any, any, any>;
    sale: LocalDatabaseSale;
    canRetrieve: boolean;
}

interface State {
    loading: boolean;
    sale: {
        id: string;
        total: number;
        note: string;
        created: string;
        user: null | string;
        customer: null | string;
        register: null | string;
        outlet: null | string;
    };
}

class HeldSale extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            loading: true,
            sale   : {
                id      : "",
                total   : 0,
                note    : "",
                created : "",
                user    : null,
                customer: null,
                register: null,
                outlet  : null,
            },
        };

        this.handleSaleClick = this.handleSaleClick.bind(this);
        this.loadSale = this.loadSale.bind(this);
    }

    public componentDidMount(): void {
        this.loadSale();
    }

    protected loadSale(): Promise<void> {
        this.setState({
            loading: true,
        });

        return this.props.data
            .then(async (source) => {
                const sale: State["sale"] = {
                    id      : this.props.sale.id,
                    total   : this.props.sale.totalPrice,
                    note    : this.props.sale.notes.sale,
                    created : this.props.sale.createdAt,
                    user    : null,
                    customer: null,
                    register: null,
                    outlet  : null,
                };

                if(this.props.sale.userId) {
                    sale.user = await source.users.get(this.props.sale.userId)
                        .then(user => {
                            return user.name;
                        })
                        .catch(() => {
                            return "Offline User";
                        });
                }

                if(this.props.sale.customerId) {
                    sale.customer = await source.customers.get(this.props.sale.customerId)
                        .then(customer => {
                            return (customer.first_name + " " + customer.last_name);
                        })
                        .catch(() => {
                            return null;
                        });
                }

                // Load the register name
                sale.register = await source.registers.get(this.props.sale.registerId)
                    .then(async register => {
                        const count = await source.outlets.count();

                        if(count > 1) {
                            // Load the outlet name
                            sale.outlet = await source.outlets.get(register.outlet_id)
                                .then(outlet => {
                                    return outlet.name;
                                });
                        }

                        return register.name;
                    });

                this.setState({
                    loading: false,
                    sale   : sale,
                });
            });
    }

    protected handleSaleClick(): void {
        if(this.props.canRetrieve) {
            this.props.dispatch(reloadInvoice(this.props.sale, false));
        }
    }

    public render(): React.ReactNode {
        let content;

        if(this.state.loading) {
            content = (
                <FontAwesomeLight icon="spinner-third" spin />
            );
        } else {
            let user = null;

            if(this.state.sale.user) {
                user = <p className="held-sale-user">{this.state.sale.user}</p>;
            }

            let customer = null;

            if(this.state.sale.customer) {
                customer = <p className="held-sale-customer">{this.state.sale.customer}</p>;
            }

            content = (
                <React.Fragment>
                    <div>
                        <p className="held-sale-timestamp">
                            {moment(this.state.sale.created).format("dddd, MMMM [of] Do YYYY")}
                        </p>
                        <div className="held-sale-register">
                            <p>{this.state.sale.outlet}</p>
                            <p>{this.state.sale.register}</p>
                        </div>
                    </div>
                    <div>
                        {customer}
                        <p className="held-sale-note">{this.state.sale.note}</p>
                    </div>
                    <div>
                        <p className="held-sale-amount"><NoTranslate>{currency(this.state.sale.total)}</NoTranslate></p>
                        {user}
                    </div>
                </React.Fragment>
            );
        }

        return (
            <div className="held-sale" onClick={this.handleSaleClick}>
                {content}
            </div>
        );
    }
}

export default connector(withDataSource(HeldSale));
